export default "__VITE_ASSET__sWCcygr$__"